import { Steps } from "antd";
import isFunction from "lodash/isFunction";
import "./index.less";
import middleware from "../../middleware";

const Step = Steps.Step;
class main extends React.Component {
  static Step = Step;
  constructor(props) {
    super(props);
    this.state = {
      current: this.props.current || 0
    };
  }

  render() {
    const {
      direction = "vertical",
      datas = [], //数据
      size = "small",
      hideStep = true, //控制是否显示数字
      className = "",
      style
    } = this.props;
    const { current } = this.state;

    //自定义steps -- 适用集成、财务模块

    if (datas && datas.length > 0) {
      return (
        <Steps
          {...this.props}
          className={`${hideStep ? "wea-steps-menus" : ""} ${className}`}
          direction={direction}
          size={size}
        >
          {datas.map(v => {
            return (
              <Step
                style={{ cursor: "pointer" }}
                status={current == Number(v.id) - 1 ? "process" : "wait"}
                title={v.menuname}
                key={v.id}
                onClick={() => {
                  this.setState({ current: Number(v.id) - 1 });
                  this.props.onChange &&
                    isFunction(this.props.onChange) &&
                    this.props.onChange(v);
                }}
              />
            );
          })}
        </Steps>
      );
    }
  }
}

const Com = middleware(main, "WeaStepsMenus");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-steps-menus/index.js